<template>
  <v-card
    data-test-id="search-product-card"
    flat
    class="rounded-xl my-6"
    elevation="0"
  >
    <slot />
  </v-card>
</template>
